export default (locales, useDisplayNameForLabel = false) =>
  locales
    .map((locale) => ({
      value: locale.code,
      label: useDisplayNameForLabel ? locale.displayName : locale.name,
    }))
    .sort((a, b) => (a.label > b.label ? 1 : -1));
